// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__111yk","info":"Note_info__3rEsj","note":"Note_note__1EJEW","actions":"Note_actions__2_vhc"};